import React from 'react';
import GenericModal from '../GenericModal';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../../../atomic/Buttons/Button';
import 'video-react/dist/video-react.css';

const ModalStyled = styled(GenericModal)`
  display: flex;
  flex-direction: column;
  height: 500px;
  padding-left: 0;
  padding-right: 0;
`
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 500px;
  white-space: pre-wrap;
  font-size: 18px;
`
const Header = styled.div`
  flex: 1;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  text-align: left;
  font-size: 22px;
  font-weight: 600;
  padding-left: 20px;
`
const Scrollable = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 30px;
`
const GuideStyled = styled.div`
  padding-bottom: 10px;
`;
const Feedback = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  justify-content: flex-end;
  padding: 10px 30px 0 0;
`;
const FAQHeader = styled.div`
  display: flex;
  padding: 20px 0 10px;
  font-weight: 600;
  font-size: 22px;
`;
const Question = styled.div`
  display: flex;
  width: 100%;
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 4px;
`;
const Answer = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 10px;
`;
const Image = styled.img`
  margin: auto;
`;

const FAQList = (props) => {
  const { faq } = props;

  const components = faq.map((item, index) => <FAQ key={`faq-${index}`} question={item.question} answer={item.answer} />);

  return components;
}

const FAQ = (props) => {
  const { question, answer } = props;
  const answerList = Array.isArray(answer) ? answer : [answer];

  const components = answerList.map((answer, index) => <Answer key={`answer-${index}`}>{answer}</Answer>);

  return (
    <>
      <Question>{question}</Question>
      {components}
    </>
  );
}

const GuideList = (props) => {
  const { guide } = props;
  const components = [];

  for (let i = 0; i < guide.length; i++) {
    components.push(<FAQ question={guide[i].heading} answer={guide[i].text} />);

    if (guide[i].image) {
      const image = require(`../../../../assets/${guide[i].image}`);
      components.push(<Image src={image} />);
    }
  }

  return components;
}

const GuideModal = ({
  header,
  guideText,
  enableFeedback,
  faq,
  guideTextList,
  children,
  src,
  ...other
}) => {
  return (
    <ModalStyled {...other}>
      <Header>{header}</Header>
      <TextContainer>
        <Scrollable>
          <GuideStyled>{guideText}</GuideStyled>
          {
            guideTextList.length > 0 &&
            <GuideList guide={guideTextList} />
          }
          {
            faq.length > 0 &&
            <>
              <FAQHeader>FAQ</FAQHeader>
              <FAQList faq={faq} />
            </>
          }
        </Scrollable>
        {
          enableFeedback &&
          <Feedback>
            <Button color="primary" variant="contained" href="mailto:appsupport@thestjames.com">Feedback</Button>
          </Feedback>
        }
      </TextContainer>
    </ModalStyled>
  );
}

GuideModal.propTypes = {
  header: PropTypes.string,
  guideText: PropTypes.string,
  enableFeedback: PropTypes.bool,
  faq: PropTypes.array,
  guideTextList: PropTypes.array,
};

GuideModal.defaultProps = {
  guideText: '',
  enableFeedback: false,
  faq: [],
  guideTextList: [],
}

export default GuideModal;
